"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ForbiddenHttpError = void 0;
const http_status_codes_1 = __importDefault(require("http-status-codes"));
const AuthHttpError_1 = require("../../Error/Http/AuthHttpError");
class ForbiddenHttpError extends AuthHttpError_1.AuthHttpError {
    constructor(message, key, token) {
        super(http_status_codes_1.default.FORBIDDEN, message, key, token);
    }
}
exports.ForbiddenHttpError = ForbiddenHttpError;
//# sourceMappingURL=ForbiddenHttpError.js.map